var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main"}},[_c('v-index',[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_vm._v("招生")]),_c('el-breadcrumb-item',[_c('a',{staticStyle:{"color":"#000000"}},[_vm._v("教师实践")])])],1),_c('v-weburl-iframe',{attrs:{"url":"student/test"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }